var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.849,
    height: 42.15,
    viewBox: "0 0 41.849 42.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 41.849,
    height: 42.15,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M18.806,42.15A18.827,18.827,0,0,1,0,23.344,23.371,23.371,0,0,1,23.344,0a.652.652,0,1,1,0,1.3A22.065,22.065,0,0,0,1.3,23.344a17.522,17.522,0,0,0,17.5,17.5A13.888,13.888,0,0,0,32.677,26.974,10.979,10.979,0,0,0,21.711,16.008a8.653,8.653,0,0,0-8.644,8.643.652.652,0,0,1-1.3,0A9.958,9.958,0,0,1,21.711,14.7a12.284,12.284,0,0,1,12.27,12.27A15.192,15.192,0,0,1,18.806,42.15",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M36.294,16.008H16.807a.652.652,0,0,1,0-1.3H35.642V1.3h-17.2a.652.652,0,1,1,0-1.3H36.294a.651.651,0,0,1,.652.652v14.7a.652.652,0,0,1-.652.652",
    transform: "translate(4.903 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M15.071,38.726a.652.652,0,1,1,0-1.3,18.022,18.022,0,0,0,18-18,17.87,17.87,0,0,0-1.511-7.228.652.652,0,0,1,1.194-.523A19.311,19.311,0,0,1,15.071,38.726",
    transform: "translate(4.376 3.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M18.442,30.114A9.416,9.416,0,1,1,27.858,20.7a9.429,9.429,0,0,1-9.416,9.416m0-17.529A8.113,8.113,0,1,0,26.555,20.7a8.122,8.122,0,0,0-8.113-8.113",
    transform: "translate(2.739 3.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M17.03,22.641a3.355,3.355,0,1,1,3.354-3.355,3.36,3.36,0,0,1-3.354,3.355m0-5.407a2.052,2.052,0,1,0,2.05,2.052,2.054,2.054,0,0,0-2.05-2.052",
    transform: "translate(4.15 4.835)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M9.676,19.82a.652.652,0,0,1-.652-.652A12.293,12.293,0,0,1,21.3,6.889a.652.652,0,1,1,0,1.3A10.988,10.988,0,0,0,10.328,19.168a.652.652,0,0,1-.652.652",
    transform: "translate(2.739 2.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M9.676,19.975a.652.652,0,0,1-.652-.652V16.461a.652.652,0,0,1,1.3,0v2.862a.652.652,0,0,1-.652.652",
    transform: "translate(2.739 4.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M35.751,8.192H18.6a.652.652,0,1,1,0-1.3H35.751a.652.652,0,1,1,0,1.3",
    transform: "translate(5.446 2.091)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M15.452,29.6a15,15,0,0,1-5.213-.927.652.652,0,0,1,.451-1.224,13.7,13.7,0,0,0,4.762.847.652.652,0,1,1,0,1.3",
    transform: "translate(2.978 8.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M10.257,34.6a.65.65,0,0,1-.335-.093A15.131,15.131,0,0,1,2.6,21.586a18.57,18.57,0,0,1,11.678-17.3A.652.652,0,0,1,14.76,5.5,17.269,17.269,0,0,0,3.9,21.586a13.823,13.823,0,0,0,6.692,11.8.652.652,0,0,1-.335,1.211",
    transform: "translate(0.788 1.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M13.79,5.054a.652.652,0,0,1-.154-1.285,18.765,18.765,0,0,1,4.406-.524.652.652,0,1,1,0,1.3,17.415,17.415,0,0,0-4.1.488.628.628,0,0,1-.154.018",
    transform: "translate(3.987 0.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M16.4,18.646a.652.652,0,0,1-.652-.652V11.933a.652.652,0,0,1,1.3,0v6.061a.652.652,0,0,1-.652.652",
    transform: "translate(4.78 3.424)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M16.069,18.735a.649.649,0,0,1-.564-.326L12.474,13.16a.651.651,0,1,1,1.128-.652l3.032,5.249a.652.652,0,0,1-.239.89.644.644,0,0,1-.326.087",
    transform: "translate(3.759 3.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M15.826,18.977a.644.644,0,0,1-.326-.087l-5.248-3.031A.652.652,0,1,1,10.9,14.73l5.248,3.031a.652.652,0,0,1-.326,1.216",
    transform: "translate(3.012 4.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M15.738,19.308H9.677a.652.652,0,1,1,0-1.3h6.061a.652.652,0,1,1,0,1.3",
    transform: "translate(2.739 5.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M10.578,23.376a.652.652,0,0,1-.326-1.216L15.5,19.129a.652.652,0,1,1,.652,1.129L10.9,23.289a.644.644,0,0,1-.326.087",
    transform: "translate(3.013 5.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M13.039,26.354a.644.644,0,0,1-.326-.087.652.652,0,0,1-.239-.89l3.032-5.249a.651.651,0,1,1,1.128.652L13.6,26.028a.649.649,0,0,1-.564.326",
    transform: "translate(3.759 6.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M16.4,27.444a.652.652,0,0,1-.652-.652V20.731a.652.652,0,0,1,1.3,0v6.061a.652.652,0,0,1-.652.652",
    transform: "translate(4.78 6.094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M20.467,26.354a.649.649,0,0,1-.564-.326l-3.031-5.249A.651.651,0,1,1,18,20.127l3.032,5.249a.652.652,0,0,1-.239.89.644.644,0,0,1-.326.087",
    transform: "translate(5.094 6.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M23.445,23.376a.644.644,0,0,1-.326-.087l-5.248-3.031a.652.652,0,1,1,.652-1.129l5.248,3.031a.652.652,0,0,1-.326,1.216",
    transform: "translate(5.325 5.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M24.536,19.308H18.475a.652.652,0,1,1,0-1.3h6.061a.652.652,0,0,1,0,1.3",
    transform: "translate(5.409 5.465)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M18.2,18.977a.652.652,0,0,1-.326-1.216l5.248-3.031a.652.652,0,0,1,.652,1.129L18.523,18.89a.644.644,0,0,1-.326.087",
    transform: "translate(5.325 4.444)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M17.437,18.735a.644.644,0,0,1-.326-.087.652.652,0,0,1-.239-.89L19.9,12.508a.651.651,0,1,1,1.128.652L18,18.409a.649.649,0,0,1-.564.326",
    transform: "translate(5.094 3.697)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.cd71f1a5ed8393e66f5138a9a1e78081.svg";
export { ForwardRef as ReactComponent };